import React from "react";
import { Navigate, Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { useI18n } from "../lib/i18n";
import { useFavorites } from "../lib/favorites";
import VehicleCard from "../components/VehicleCard";
import { Heart, ArrowRight } from "lucide-react";

export default function FavoritesPage() {
  const { user } = useAuth();
  const { items } = useFavorites();
  const { t, lang } = useI18n();

  if (user === undefined) return <div className="p-10 text-[#6b6b6b]">{t("common.loading")}</div>;
  if (!user) return <Navigate to="/login" state={{ from: "/favorites" }} replace />;

  return (
    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-10" data-testid="favorites-page">
      <div className="overline mb-2 inline-flex items-center gap-2"><Heart className="w-3 h-3" /> FAVORITES</div>
      <h1 className="font-display text-4xl tracking-tight font-medium">
        {lang === "ar" ? "المفضلة" : "Your favorites"}
      </h1>
      <p className="text-[#6b6b6b] mt-2">
        {items.length} {lang === "ar" ? "مركبة محفوظة" : items.length === 1 ? "vehicle saved" : "vehicles saved"}
      </p>

      {items.length === 0 ? (
        <div className="surface rounded-3xl p-16 text-center mt-12">
          <Heart className="w-12 h-12 mx-auto text-[#8a6f2e] mb-4" />
          <p className="text-[#525252]">
            {lang === "ar" ? "لم تحفظ أي سيارة بعد. ابدأ بحفظ السيارات التي تعجبك." : "You haven't saved any vehicles yet. Tap the heart on any listing to save it."}
          </p>
          <Link to="/marketplace" className="btn-primary mt-6 inline-flex" data-testid="favorites-browse">
            {lang === "ar" ? "تصفح السوق" : "Browse marketplace"} <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      ) : (
        <div className="columns-1 sm:columns-2 lg:columns-3 xl:columns-4 gap-5 mt-8 [&>*]:break-inside-avoid [&>*]:mb-5">
          {items.map((f) => <VehicleCard key={f.id} v={f.vehicle} />)}
        </div>
      )}
    </div>
  );
}
